import StatsRule from "../../../common/stats-rule";
import DriveService from "../../../../services/drive-service";
import FootballStatsCategory from "../../stats/football-stats-category";

export default class UpdateContextStats extends StatsRule {
    // eslint-disable-next-line no-unused-vars
    async apply(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        const { score } = play.contextSnapshot;
        const previousHomeScore = score[0];
        const previousAwayScore = score[1];

        const { awayScore, homeScore } = fragment.values;

        const stats = [];

        if (homeScore && previousHomeScore !== homeScore) {
            this.addStats(
                {
                    gameId: play.gameId,
                    playId: play.id,
                    period: gameContext.currentPeriod,
                    teamId: gameContext.homeTeamId,
                    playerId: null,
                    driveId: await DriveService.resolveDriveId(
                        play,
                        gameContext
                    ),
                    fragmentId: fragment.id,
                    category: FootballStatsCategory.UPDATE_CONTEXT,
                    values: { points: homeScore - previousHomeScore }
                },
                stats
            );
        }

        if (awayScore && previousAwayScore !== awayScore) {
            this.addStats(
                {
                    gameId: play.gameId,
                    playId: play.id,
                    period: gameContext.currentPeriod,
                    teamId: gameContext.awayTeamId,
                    playerId: null,
                    driveId: await DriveService.resolveDriveId(
                        play,
                        gameContext
                    ),
                    fragmentId: fragment.id,
                    category: FootballStatsCategory.UPDATE_CONTEXT,
                    values: { points: awayScore - previousAwayScore }
                },
                stats
            );
        }

        return stats;
    }
}
